{
    "Accessibility Menu": "Barrierefreiheit",
    "Reset settings": "Einstellungen zurücksetzen",
    "Close": "Schließen",
    "Content Adjustments": "Inhaltsanpassungen",
    "Adjust Font Size": "Schriftgröße anpassen",
    "Highlight Title": "Titel hervorheben",
    "Highlight Links": "Links hervorheben",
    "Readable Font": "Lesbare Schrift",
    "Color Adjustments": "Farbanpassungen",
    "Dark Contrast": "Dunkler Kontrast",
    "Light Contrast": "Heller Kontrast",
    "High Contrast": "Hoher Kontrast",
    "High Saturation": "Hohe Farbsättigung",
    "Low Saturation": "Niedrige Farbsättigung",
    "Monochrome": "Monochrom",
    "Tools": "Werkzeuge",
    "Reading Guide": "Lesehilfe",
    "Stop Animations": "Animationen stoppen",
    "Big Cursor": "Großer Cursor",
    "Increase Font Size": "Schriftgröße vergrößern",
    "Decrease Font Size": "Schriftgröße verkleinern",
    "Letter Spacing": "Zeichenabstand",
    "Line Height": "Zeilenhöhe",
    "Font Weight": "Schriftstärke",
    "Dyslexia Font": "Dyslexie-Schrift",
    "Language": "Sprache",
    "Open Accessibility Menu": "Barrierefreiheitsmenü öffnen"
}